import { InputHTMLAttributes, forwardRef } from 'react'

export interface TToggleButtonProps extends InputHTMLAttributes<HTMLInputElement> {
  onToggleButton: (state: boolean) => void
  state?: boolean
}

const ToggleButton = forwardRef<HTMLInputElement, TToggleButtonProps>(function ToggleButton(
  { onToggleButton, state = false, ...toggleProps },
  ref,
) {
  return (
    <div className='h-[18px] w-9'>
      <label className='relative inline-block h-full w-full'>
        <input
          {...toggleProps}
          ref={ref}
          type='checkbox'
          checked={state}
          onChange={() => onToggleButton(!state)}
          className='h-0 w-0 opacity-0'
        />
        <div
          className={`absolute bottom-0 left-0 right-0 top-0 cursor-pointer rounded-full  transition 
        ${state ? 'bg-pop-dodger-blue' : 'bg-pop-grey-300 '}`}
          data-testid='toggle-background'
        />
        <div
          className={`absolute left-[2px] top-[2px] h-[14px] w-[14px] transform cursor-pointer rounded-full bg-white transition 
        ${state ? 'translate-x-[18px]' : ''}`}
          data-testid='toggle-thumb'
        />
      </label>
    </div>
  )
})

export default ToggleButton
